import script from "./BannerTemp.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerTemp.vue?vue&type=script&setup=true&lang=js"

import "./BannerTemp.vue?vue&type=style&index=0&id=7967e0a1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7967e0a1"]])

export default __exports__